import { render, staticRenderFns } from "./ProgramMemberResultAssignmentComponent.vue?vue&type=template&id=42be20da&"
import script from "./ProgramMemberResultAssignmentComponent.vue?vue&type=script&lang=js&"
export * from "./ProgramMemberResultAssignmentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports